import React from 'react'
import { rootUseStyles } from '../fluent-style';

export default function Footer() {
    const styles = rootUseStyles();
    return (
        <footer className={styles.footer} aria-label="Footer">
            <p className={styles.paragraph}>Powered by AQUILA</p>
            <div className={styles.legalLinks}>
                <a href="https://usdc.cytechint.io/terms" target="_blank" rel="noopener noreferrer" className={styles.link}>Terms and Conditions</a>
                <a href="https://usdc.cytechint.io/license-agreement" target="_blank" rel="noopener noreferrer" className={styles.link}>License Agreement</a>
                <a href="https://www.cytechint.com/privacy-policy" target="_blank" rel="noopener noreferrer" className={styles.link}>Privacy Policy</a>
            </div>
        </footer>
    )
}
